import { render, staticRenderFns } from "./gyra-store-card.vue?vue&type=template&id=4e2e552e&scoped=true&"
import script from "./gyra-store-card.vue?vue&type=script&lang=js&"
export * from "./gyra-store-card.vue?vue&type=script&lang=js&"
import style0 from "./gyra-store-card.vue?vue&type=style&index=0&id=4e2e552e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e552e",
  null
  
)

export default component.exports